module.exports = __webpack_public_path__ + "img/9788959522873.f63e2dc0.jpg";